import styled from 'styled-components';
import { EyebrowStyles } from '../../shared/Eyebrow.styles';
import { breakpointUp } from '../../../styles/mediaUtils';
import { typeScale } from '../../../styles/newTypography';
import { spacing } from '../../../styles/newThemeVariables.styles';

export const Title = styled.h2`
  ${EyebrowStyles}
  color: ${({ theme }) => theme.textPrimary};
`;

export const Content = styled.div`
  ${typeScale.mobile.body.md}

  @media ${breakpointUp.tablet} {
    ${typeScale.tablet.body.lg}
  }

  @media ${breakpointUp.desktop} {
    ${typeScale.desktop.body.lg}
  }
`;

export const StyledGridItem = styled.div`
  grid-column: 1 / -1;
  margin-bottom: ${spacing.space36};

  @media ${breakpointUp.tablet} {
    margin-bottom: ${spacing.space72};
  }

  @media ${breakpointUp.desktop} {
    grid-column: 1 / span 6;
    margin-bottom: 0;
  }
`;

export const StyledBlockContent = styled.div`
  grid-column: 1 / -1;

  @media ${breakpointUp.desktop} {
    grid-column: 8 / span 5;
  }
`;
